import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import Select from '../../../../components/forms/Select'
import Job from '../../../dto/DtoJob'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { CardTable } from '../../../../components/datatable/NewTable'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { Button, Grid } from '@mui/material'
import RadioButtons from '../../../../components/forms/RadioButtons'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { readImportCsvStationsCodes } from 'import/components/utils/ImportUtils'
import { uniq } from 'lodash'
import {
    CITIES,
    DATA,
    DATA_ADD_NEW_DATA,
    DEBIT_INTEGRATION,
    DEPARTMENTS,
    HEIGHT_INTEGRATION,
    MAX,
    MIN,
    MOY,
    STATION_INTEGRATION,
    STATIONS,
    WITHPRED,
} from 'traitements/constants/TraitementConstants'
import { HOUR } from 'utils/constants/MeasureConstants'
import { DAY } from 'utils/constants/CalandarConstants'

const HydroPanel = ({
    job,
    addHydroCode,
    isEditMode,
    onChangeDataTypes,
    onChangeJob,
}) => {
    const dispatch = useDispatch()
    const [hydroCode, setHydroCode] = useState('')
    const { parameters } = job

    useEffect(() => {
        if (!(job?.parameters?.dataTypes ?? []).length) {
            onChangeDataTypes([
                STATION_INTEGRATION,
                DATA_ADD_NEW_DATA,
                HEIGHT_INTEGRATION,
                DEBIT_INTEGRATION,
            ])
        }
    }, [])

    const getFilters = () => (
        job.parameters.filters.length ? JSON.parse(job.parameters.filters[0]) : { stationsMode: STATIONS }
    )

    const onChangeFilters = (changes) => {
        const newParameters = {
            ...job.parameters,
            filters: [JSON.stringify({
                ...getFilters(),
                ...changes,
            })],
        }
        onChangeJob({ parameters: newParameters })
    }

    const getDataTypes = (type) => {
        return (parameters.dataTypes?.length) ? parameters.dataTypes.find(d => d.includes(type)) || '' : ''
    }

    const changeDataTypes = (integration, integrationValue) => {
        const data = job.parameters.dataTypes.filter(d => !d.includes(integrationValue))
        onChangeDataTypes(integration ? [...data, integrationValue] : data)
    }

    const handleChangeDataIntegration = (integration) => {
        const data = parameters.dataTypes.filter(d => !d.includes(DATA))
        const newDataTypes = integration ? [...data, integration] : data
        onChangeDataTypes(newDataTypes)
    }

    const handleChangeStationIntegration = (integration) => {
        const data = parameters.dataTypes.filter(d => d !== STATION_INTEGRATION)
        const dataTypes = integration ? [...data, STATION_INTEGRATION] : data
        onChangeDataTypes(dataTypes)
    }

    const getStations = (filters) => {
        switch (filters.stationsMode) {
            case CITIES:
                return filters.cities ?? []
            case DEPARTMENTS:
                return filters.departments ?? []
            default:
                return job.parameters.parameters
        }
    }

    const onDeleteHydroCode = ({ hydroCodeRow }) => {
        const filters = getFilters()
        if (isEditMode) {
            if (filters.stationsMode === STATIONS) {
                addHydroCode(job.parameters.parameters.filter(p => p !== hydroCodeRow))
            } else {
                const list = (filters[filters.stationsMode] ?? []) .filter(p => p !== hydroCodeRow)
                onChangeFilters({
                    [filters.stationsMode]: list,
                })
            }
        }
    }


    const addHydroCodeHandler = (filters) => {
        if (!isEditMode) {
            return
        }
        const code = hydroCode.replaceAll(' ', '')
        if (filters.stationsMode === STATIONS) {
            const exist = job.parameters.parameters.find(p => p.toLowerCase() === code.toLowerCase())
            if (!code) {
                dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneCode))
            } else if (exist) {
                dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisCode))
            } else {
                addHydroCode([
                    code,
                    ...job.parameters.parameters,
                ])
                setHydroCode('')
            }
        } else {
            const exist = (filters[filters.stationsMode] ?? []).find(p => p.toLowerCase() === code.toLowerCase())
            if (!code) {
                dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneCode))
            } else if (exist) {
                dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisCode))
            } else {
                onChangeFilters({
                    [filters.stationsMode]: [
                        code,
                        ...(filters[filters.stationsMode] ?? []),
                    ],
                })
                setHydroCode('')
            }
        }
    }

    const onChangeHydroFile = (e) => {
        readImportCsvStationsCodes(e, { importFile: e.target }, (codes) => {
            const filters = getFilters()
            if (filters.stationsMode === STATIONS) {
                addHydroCode(
                    uniq([
                        ...codes,
                        ...job.parameters.parameters,
                    ]),
                )
            } else {
                onChangeFilters({
                    [filters.stationsMode]: uniq([
                        ...codes,
                        ...(filters[filters.stationsMode] ?? []),
                    ]),
                })
            }
        },
        )
    }

    const getFrequence = [
        { value: '', label: '' },
        { value: HOUR, label: i18n.hour },
        { value: DAY, label: i18n.day },
    ]

    const getRounded = [
        { value: '', label: '' },
        { value: MAX, label: i18n.max },
        { value: MOY, label: i18n.average },
        { value: MIN, label: i18n.min },
    ]

    const disabled = { disabled: !isEditMode }
    const filters = getFilters()

    const stationsCodes = getStations(filters).map(hydroCodeRow => ({ hydroCodeRow }))

    const codesTypes = [
        { code: STATIONS, name: i18n.stations },
        { code: CITIES, name: i18n.cities },
        { code: DEPARTMENTS, name: i18n.departments },
    ]

    return (
        <Grid container spacing={2} alignItems='center' padding={1} >
            <Grid size={3}>
                <Checkbox
                    checked={!!getDataTypes(STATION_INTEGRATION)}
                    label={i18n.integrateStationInfo}
                    onChange={handleChangeStationIntegration}
                    {...disabled}
                />
            </Grid>
            <Grid size={3}>
                <Checkbox
                    checked={filters.doNotImportClosedStations}
                    label={i18n.doNotImportClosedStations}
                    onChange={v => onChangeFilters({ doNotImportClosedStations: v })}
                    {...disabled}
                />
            </Grid>
            <Grid size={3}>
                <Select
                    value={getDataTypes(DATA)}
                    options={getIntegrationModes()}
                    label={i18n.dataIntegration}
                    labelSpan={<IntegrationModeDialog />}
                    onChange={handleChangeDataIntegration}
                    {...disabled}
                />
            </Grid>
            <Grid size={3}>
                <RadioButtons
                    elements={codesTypes}
                    selected={filters.stationsMode}
                    onChange={v => onChangeFilters({ stationsMode: v })}
                    title={i18n.schemeAgencyID}
                    {...disabled}
                />
            </Grid>
            <Grid size={3}>
                <Checkbox
                    checked={!!getDataTypes(WITHPRED)}
                    label={`${i18n.importPrevData} ${i18n.vigicrues}`}
                    onChange={v => changeDataTypes(v, WITHPRED)}
                    {...disabled}
                />
            </Grid>

            <Grid size={4} offset={3}>
                <Button
                    variant='contained'
                    component='label'
                    fullWidth
                    {...disabled}
                >
                    {i18n.importLabelStation}
                    <input
                        type='file'
                        accept='.csv'
                        hidden
                        onChange={onChangeHydroFile}
                        {...disabled}
                    />
                </Button>
            </Grid>

            <Grid size={4} offset={3}>
                <label className='tinyLabel'>{i18n.stationHYDROCode}</label>
                <input
                    id='txtAddHydroCode'
                    type='text'
                    value={hydroCode}
                    placeholder={i18n.HYDROExample}
                    onChange={(e) => setHydroCode(e.target.value)}
                    {...disabled}
                />
            </Grid>
            <Grid size={5}>
                <Grid container>
                    <Grid size={3} offset={1}>
                        <a
                            className='waves-effect waves-light btn'
                            onClick={() => addHydroCodeHandler(filters)}
                            {...disabled}
                        >
                            {i18n.add}
                        </a>
                    </Grid>
                </Grid>
            </Grid>

            <Grid size={2}>
                <Checkbox
                    checked={!!getDataTypes(HEIGHT_INTEGRATION)}
                    label={i18n.heightObs}
                    onChange={v => changeDataTypes(v, HEIGHT_INTEGRATION)}
                    {...disabled}
                />
            </Grid>
            <Grid size={2}>
                <Checkbox
                    checked={!!getDataTypes(DEBIT_INTEGRATION)}
                    label={i18n.debitObs}
                    onChange={v => changeDataTypes(v, DEBIT_INTEGRATION)}
                    {...disabled}
                />
            </Grid>
            <Grid size={2}>
                <Checkbox
                    checked={!!getDataTypes('withEvents')}
                    label={i18n.importEvents}
                    onChange={v => changeDataTypes(v, 'withEvents')}
                    {...disabled}
                />
            </Grid>
            <Grid size={2}>
                <Checkbox
                    checked={!!getDataTypes('withThresholds')}
                    label={i18n.importThresholds}
                    onChange={v => changeDataTypes(v, 'withThresholds')}
                    {...disabled}
                />
            </Grid>
            <Grid size={2}>
                <Select
                    value={filters.frequency || ''}
                    options={getFrequence}
                    label={i18n.frequency}
                    onChange={v => onChangeFilters({ frequency: v })}
                    {...disabled}
                />
            </Grid>
            <Grid size={2}>
                <Select
                    value={filters.rounded || ''}
                    options={getRounded}
                    label={i18n.averageOrMaximum}
                    onChange={v => {
                        if (['', undefined].includes(filters.frequency)) {
                            dispatch(ToastrAction.error(i18n.pleaseAlsoProvideTheFrequency))
                        }

                        onChangeFilters({ rounded: v })
                    }}
                    {...disabled}
                />
            </Grid>

            <Grid size={12}>
                <CardTable
                    headers={['hydroCodeRow']}
                    rows={stationsCodes}
                    title={filters.stationsMode === STATIONS ? i18n.credentials : i18n[filters.stationsMode]}
                    lineActions={[
                        { icon: 'delete', onClick: onDeleteHydroCode, displayed: isEditMode },
                    ]}
                    actions={[
                        {
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [
                                    {
                                        ...(stationsCodes[0]),
                                        headers: ['hydroCodeRow'],
                                    },
                                    ...stationsCodes.slice(1, stationsCodes.length),
                                ],
                                titleFile: i18n.credentials,
                            }),
                            tooltip: i18n.download,
                        },
                    ]}
                    displayHeaders={false}
                />
            </Grid>
        </Grid>
    )
}

HydroPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addHydroCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeJob: PropTypes.func,
}


export default HydroPanel